module.exports = __webpack_public_path__ + "static/media/canteen.52ebfb1a.jpg";